<div class="profile-container">
  <div class="column-0">
    <div class="settings-section">
      <div class="avatar-section">
        <div [style]="organisationLogoStyle" alt="Avatar" class="avatar-img">
          <input
            type="file"
            accept=".jpeg, .jpg, .png, .svg"
            (change)="uploadFile($event)"
            id="file-upload"
            class="file-input avatar"
            *ngIf="!isPreview"
          />
        </div>
        <div class="avatar-right">
          <button
            class="change-avatar-btn not-selectable"
            for="file-upload"
            [disabled]="isPreview"
            [class.disabled]="isPreview"
            (click)="onAvatarChange($event)"
          >
            {{ 'organisation.changeLogo' | translate }}
          </button>
          <div class="avatar-info not-selectable">
            {{ 'organisation.optimalSize' | translate }}
          </div>
        </div>
      </div>

      <div class="profile-form">
        <ops-input
          (validationError)="onErrorHandler($event, 'name')"
          [isPreview]="isPreview"
          label="{{ 'organisation.organisationName' | translate }}"
          formName="selectedCompany.name"
          [value]="selectedCompany.name"
          (changed)="onInputChange($event, 'name')"
          type="text"
          mandatory="true"
        ></ops-input>

        <ops-input
          (validationError)="onErrorHandler($event, 'shortName')"
          [isPreview]="isPreview"
          label="{{ 'organisation.organisationShortName' | translate }}"
          formName="selectedCompany.shortName"
          [value]="selectedCompany.shortName"
          (changed)="onInputChange($event, 'shortName')"
          type="text"
          mandatory="true"
        ></ops-input>

        <ops-input
          (validationError)="onErrorHandler($event, 'mainPlaceOfWork')"
          [isPreview]="isPreview"
          label="{{ 'organisation.mainPlaceOfWork' | translate }}"
          formName="selectedCompany.mainPlaceOfWork"
          [value]="selectedCompany.mainPlaceOfWork"
          (changed)="onInputChange($event, 'mainPlaceOfWork')"
          type="text"
        ></ops-input>

        <ops-input-with-list-items
          [isPreview]="isPreview"
          label="{{ 'organisation.otherPlacesOfWork' | translate }}"
          showLimitNote="true"
          formName="selectedCompany.otherPlacesOfWork"
          [defaultSelected]="selectedCompany.otherPlacesOfWork"
          (changed)="onSelectChange($event, 'otherPlacesOfWork')"
        ></ops-input-with-list-items>

        <!-- <ops-select [isPreview]="isPreview" allowCreate="true"
          [defaultSelected]="selectedCompany.otherPlacesOfWork" [formName]="selectedCompany.otherPlacesOfWork" label="Other Place/s of Work"
          (changed)="onSelectChange($event, 'businessType')"></ops-select> -->

        <ops-input
          (validationError)="onErrorHandler($event, 'address')"
          [isPreview]="isPreview"
          label="{{ 'organisation.businessAddress' | translate }}"
          formName="selectedCompany.address"
          [value]="selectedCompany.address"
          (changed)="onInputChange($event, 'address')"
          type="text"
        ></ops-input>

        <ops-input
          (validationError)="onErrorHandler($event, 'email')"
          [isPreview]="isPreview"
          label="{{ 'organisation.businessEmail' | translate }}"
          formName="selectedCompany.email"
          [value]="selectedCompany.email"
          (changed)="onInputChange($event, 'email')"
          type="email"
        ></ops-input>

        <ops-input
          (validationError)="onErrorHandler($event, 'phone')"
          [isPreview]="isPreview"
          label="{{ 'organisation.businessPhone' | translate }}"
          formName="selectedCompany.phone"
          [value]="selectedCompany.phone"
          (changed)="onInputChange($event, 'phone')"
          type="phone"
        ></ops-input>

        <ops-select
          [isPreview]="isPreview"
          [options]="businessTypes"
          showLimitNote="true"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="selectedCompany.businessType"
          [formName]="selectedCompany.businessType"
          label="{{ 'organisation.businessType' | translate }}"
          (changed)="onSelectChange($event, 'businessType')"
        ></ops-select>
      </div>
    </div>
    <div class="settings-section no-bottom">
      <div class="profile-form">
        <ops-select
          [isDisabled]="true"
          rotateDropdownDirection="'true'"
          [isPreview]="true"
          [options]="mainCurrencies"
          [defaultSelected]="selectedCompany.baseCurrencyCode"
          [formName]="selectedCompany.baseCurrencyCode"
          mandatory="true"
          label="{{ 'organisation.mainCurrency' | translate }}"
          (changed)="onSelectChange($event, 'baseCurrencyCode')"
        ></ops-select>
      </div>
    </div>
  </div>

  <div class="column-1">
    <div class="settings-section">
      <label class="section-label">{{
        'organisation.organisationDetails' | translate
      }}</label>
      <div class="profile-form">
        <ops-select
          [isPreview]="isPreview"
          [options]="creativeIndustrySectors"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="selectedCompany.creativeIndustrySector"
          [formName]="selectedCompany.creativeIndustrySector"
          label="{{ 'organisation.creativeIndustrySector' | translate }}"
          (changed)="onSelectChange($event, 'creativeIndustrySector')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="marketDomainsList"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="selectedCompany.marketDomains"
          [formName]="selectedCompany.marketDomains"
          label="{{ 'organisation.marketDomain' | translate }}"
          showLimitNote="true"
          isMultiselect="true"
          maxSelect="3"
          (changed)="onSelectChange($event, 'marketDomains')"
        ></ops-select>

        <ops-select
          [isPreview]="isPreview"
          [options]="keyServicesList"
          showSearch="true"
          allowCreate="true"
          [defaultSelected]="selectedCompany.keyServices"
          [formName]="selectedCompany.keyServices"
          label="{{ 'organisation.keyServices' | translate }}"
          (changed)="onSelectChange($event, 'keyServices')"
        ></ops-select>

        <ops-input
          (validationError)="onErrorHandler($event, 'jurisdictionResidency')"
          [isPreview]="isPreview"
          [value]="selectedCompany.jurisdictionResidency"
          [formName]="selectedCompany.jurisdictionResidency"
          label="{{ 'organisation.jurisdictionResidency' | translate }}"
          (changed)="onInputChange($event, 'jurisdictionResidency')"
          type="text"
        ></ops-input>

        <!-- <ops-input
          [isPreview]="isPreview"
          label="Date of Establishment"
          formName="selectedCompany.dateOfEstablishment"
          [value]="selectedCompany.dateOfEstablishment"
          (changed)="onInputChange($event, 'dateOfEstablishment')"
          type="text"
        ></ops-input> -->

        <ops-calendar
          label="{{ 'organisation.dateOfEstablishment' | translate }}"
          (dateChanged)="updateDateOfEstablishment($event)"
          [isPreview]="isPreview"
          formName="selectedCompany.dateOfEstablishment"
          [date]="selectedCompany.dateOfEstablishment"
        ></ops-calendar>

        <!-- <ops-input
          (validationError)="onErrorHandler($event, 'balance')"
          [isPreview]="isPreview"
          label="Balance"
          decimalValue="true"
          formName="selectedCompany.balance"
          [value]="selectedCompany.balance"
          (changed)="onInputChange($event, 'balance')"
          type="text"
        ></ops-input> -->

        <ops-input
          (validationError)="onErrorHandler($event, 'numberOfMembers')"
          [isPreview]="isPreview"
          label="{{ 'organisation.numberOfMembers' | translate }}"
          formName="selectedCompany.numberOfMembers"
          [value]="selectedCompany.numberOfMembers"
          (changed)="onInputChange($event, 'numberOfMembers')"
          type="number"
        ></ops-input>

        <div class="nfut-container overflow-visible">
          <ops-input-preview
            label="{{ 'organisation.fiscalYearStartMonth' | translate }}"
            [isPreview]="isPreview"
            [value]="selectedCompany.fiscalYearStartMonth"
            type="text"
          ></ops-input-preview>

          <ops-input-preview
            [isPreview]="isPreview"
            label="{{ 'organisation.fiscalYearStartDay' | translate }}"
            [value]="selectedCompany.fiscalYearStartDay"
            type="text"
          ></ops-input-preview>

          <!-- <ops-select
            [isPreview]="isPreview"
            [options]="monthOptions"
            [defaultSelected]="selectedCompany.fiscalYearStartMonth"
            [formName]="selectedCompany.fiscalYearStartMonth"
            mandatory="true"
            label="Fiscal Year Start Month"
            (changed)="onInputChange($event, 'fiscalYearStartMonth')"
          ></ops-select>


          <ops-select
            mandatory="true"
            [isPreview]="isPreview"
            [isDisabled]="'true'"
            [options]="dayOptions"
            [defaultSelected]="selectedCompany.fiscalYearStartDay"
            [formName]="selectedCompany.fiscalYearStartDay"
            label="Fiscal Year Start Day"
            (changed)="onInputChange($event, 'fiscalYearStartDay')"
          ></ops-select> -->
        </div>
        <div class="nfut-container">
          <ops-input
            [isPreview]="isPreview"
            label="{{ 'organisation.uniqueId' | translate }}"
            [value]="selectedCompany.companyId"
            formName="selectedCompany.companyId"
            (changed)="onInputChange($event, 'companyId')"
            type="text"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'taxId')"
            [isPreview]="isPreview"
            label="{{ 'organisation.taxId' | translate }}"
            formName="selectedCompany.taxId"
            [value]="selectedCompany.taxId"
            (changed)="onInputChange($event, 'taxId')"
            type="text"
          ></ops-input>
        </div>
      </div>
    </div>
  </div>

  <div class="column-2">
    <div class="settings-section">
      <label class="section-label">{{ 'labels.socials' | translate }}</label>
      <div class="profile-form two-cols">
        <div class="left-block">
          <ops-input
            (validationError)="onErrorHandler($event, 'website')"
            [isPreview]="isPreview"
            label="{{ 'organisation.website' | translate }}"
            formName="selectedCompany.website"
            [value]="selectedCompany.website"
            (changed)="onInputChange($event, 'website')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'linkedin')"
            [isPreview]="isPreview"
            label="{{ 'organisation.linkedin' | translate }}"
            formName="selectedCompany.linkedin"
            [value]="selectedCompany.linkedin"
            (changed)="onInputChange($event, 'linkedin')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'youtube')"
            [isPreview]="isPreview"
            label="{{ 'organisation.youtube' | translate }}"
            formName="selectedCompany.youtube"
            [value]="selectedCompany.youtube"
            (changed)="onInputChange($event, 'youtube')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'vimeo')"
            [isPreview]="isPreview"
            label="{{ 'organisation.vimeo' | translate }}"
            formName="selectedCompany.vimeo"
            [value]="selectedCompany.vimeo"
            (changed)="onInputChange($event, 'vimeo')"
            type="url"
          ></ops-input>
        </div>
        <div class="right-block">
          <ops-input
            (validationError)="onErrorHandler($event, 'instagram')"
            [isPreview]="isPreview"
            label="{{ 'organisation.instagram' | translate }}"
            formName="selectedCompany.instagram"
            [value]="selectedCompany.instagram"
            (changed)="onInputChange($event, 'instagram')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'tiktok')"
            [isPreview]="isPreview"
            label="{{ 'organisation.tiktok' | translate }}"
            formName="selectedCompany.tiktok"
            [value]="selectedCompany.tiktok"
            (changed)="onInputChange($event, 'tiktok')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'imdb')"
            [isPreview]="isPreview"
            label="{{ 'organisation.imdb' | translate }}"
            formName="selectedCompany.imdb"
            [value]="selectedCompany.imdb"
            (changed)="onInputChange($event, 'imdb')"
            type="url"
          ></ops-input>

          <ops-input
            (validationError)="onErrorHandler($event, 'x')"
            [isPreview]="isPreview"
            label="{{ 'organisation.x' | translate }}"
            formName="selectedCompany.x"
            [value]="selectedCompany.x"
            (changed)="onInputChange($event, 'x')"
            type="url"
          ></ops-input>
        </div>
      </div>
      <div class="additional-channels">
        <ng-container
          *ngFor="
            let adChannel of selectedCompany.additionalSocialMediaChannels;
            let i = index
          "
        >
          <div class="ad-channel-wrapper" id="ad-channel-{{ i }}">
            <ops-input
              (validationError)="onErrorHandler($event, adChannel.name)"
              [isPreview]="isPreview"
              label="{{ adChannel.name }}"
              formName="{{ adChannel.name }}"
              [value]="adChannel.url"
              (changed)="onAdditionalChannelChange($event, adChannel.name)"
              type="url"
            ></ops-input>
            <button
              tabindex="-1"
              *ngIf="!isPreview"
              (click)="removeAdChannel(adChannel)"
            >
              {{ 'common.remove' | translate }}
            </button>
          </div>
        </ng-container>
      </div>
      <ops-add-additional-media-channel
        [isPreview]="isPreview"
        (createdChannel)="createNewChannel($event)"
      ></ops-add-additional-media-channel>
    </div>
    <div class="settings-section no-bottom">
      <div class="profile-form file-upload">
        <ops-file-upload-button
          [isPreview]="isPreview"
          [fieldUrlName]="'sealUrl'"
          [fieldUrlValue]="selectedCompany.sealUrl"
          [uploadApiUrl]="'uploadSeal'"
          [companyId]="selectedCompany._id"
          label="{{ 'organisation.companyStamp' | translate }}"
          (selectedFileUrl)="selectedCompanyStamp($event)"
        ></ops-file-upload-button>
        <ops-file-upload-button
          [fieldUrlName]="'signatureUrl'"
          [fieldUrlValue]="selectedCompany.signatureUrl"
          [allowedFormats]="['image/png', 'image/svg+xml']"
          [uploadApiUrl]="'uploadSignature'"
          [isPreview]="isPreview"
          [companyId]="selectedCompany._id"
          label="{{ 'organisation.signature' | translate }}"
          (selectedFileUrl)="selectedSignatureFile($event)"
        ></ops-file-upload-button>
      </div>
    </div>
  </div>
</div>
